const zevTypes = ["BEV", "PHEV", "FCEV", "EREV"];
const zevClasses = ["A", "B", "C"];
const vehicleClasses = [
  "Two-seater",
  "Minicompact (less than 85 cu. ft.)",
  "Subcompact (85–99 cu. ft.)",
  "Compact (100–109 cu. ft.)",
  "Mid-size (110–119 cu. ft.)",
  "Full-size (120 cu. ft. or more)",
  "Station wagon: Small (less than 130 cu. ft.)",
  "Station wagon: Mid-size (130–159 cu. ft.)",
  "Pickup truck: Small (less than 2,722 kg)",
  "Pickup truck: Standard (2,722–3,856 kg)",
  "Sport utility vehicle: Small (less than 2,722 kg)",
  "Sport utility vehicle: Standard (2,722–4,536 kg)",
  "Minivan (less than 3,856 kg)",
  "Van: Cargo (less than 3,856 kg)",
  "Van: Passenger (less than 4,536 kg)",
  "Special purpose vehicle (less than 3,856 kg)",
  "Other/TBD",
];

export { zevTypes, zevClasses, vehicleClasses };
